import "bootstrap-icons/font/bootstrap-icons.css";

import { Link } from "react-router-dom";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { handleOpenPdf } from "utils";

import rates from "assets/pdf/deposits/CMCA-FCY-Rates -Rate-Segments_190924.pdf";
import pds from "assets/pdf/deposits/ENG PDS CM FCY CA-i.pdf";
import currency from "assets/images/currency_2.svg";
import fees1 from "assets/images/fees_table_fc.svg";
import DepositImage from "assets/images/hero-images/Banner_Deposit.png";
import BG from "assets/images/hero-images/BG.png";

function Commodity() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Deposits"
          title={`Commodity Murabahah<br>
              <span className="jumbotron-subtitle-2">
                Foreign Currency Current Account-<em>i</em>
              </span>`}
          buttonText="Apply Now"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
          backgroundImage={DepositImage}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Need good returns on your Savings account? Our Commodity Murabahah
              Savings Account-i offers you the benefit of good return for your
              money and freedom of a Visa Debit-ATM Card-i.
            </p>
            <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial deposit of</div>
                <div className="column-subheader">
                  USD 1,000 or its equivalent (Individual)
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">RM 0</div>
                <div className="column-subheader">
                  No minimum balance to maintain
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Attractive returns</div>
                <div className="column-subheader">
                  Under simple tier rates which is calculated daily and paid
                  monthly
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Overseas</div>
                <div className="column-subheader">
                  Expand your opportunities overseas with an account that hedges
                  against foreign currency fluctuations as they keep it for
                  future use
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Protected by PIDM</div>
                <div className="column-subheader">
                  Up to RM250,000 for each depositor
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Shariah Contract</div>
                <div className="column-subheader">
                  Commodity Murabahah (via Tawarruq arrangement)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={fees1}
              className="d-inline-block align-top"
              alt=""
            />
            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <Link to="/e-application-form" className="w-full">
                <LinkButton text="e-Application Form" />
              </Link>
              <LinkButton
                text="Profit Rates"
                onClick={() => handleOpenPdf(rates)}
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(pds)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect!</h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
      {/* <MainFooter />
      <SubFooter /> */}
    </div>
  );
}

export default Commodity;
